import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { loadLevel, raceBadgeStyle } from '../../lib/trackerCalendar';

const LEVEL_CLASS = {
    free: 'text-success',
    tight: 'text-warning',
    over: 'text-danger',
};

@observer
class RaceTrackerDayDrawer extends Component {
    render() {
        const { date, races = [], pool = 0 } = this.props;
        const needed = races.reduce((sum, r) => sum + (Number(r.trackersNeeded) || 0), 0);
        const level = loadLevel(needed, pool);
        const free = pool - needed;
        const dateText = date ? new Date(`${date}T12:00:00`).toLocaleDateString('nb-NO', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
        }) : '';

        return (
            <div class='w-100 p-3'>
                <h5 class='mb-1'>
                    <i class='fa-solid fa-satellite-dish me-2' />
                    {dateText}
                </h5>
                <div class={`mb-3 ${LEVEL_CLASS[level]}`}>
                    <Text id='tracker-calendar.day-summary' fields={{ needed, pool, free }}>
                        {needed} of {pool} trackers reserved, {free} free
                    </Text>
                </div>
                {races.length === 0 ? (
                    <div class='text-body-secondary'>
                        <Text id='tracker-calendar.no-races'>No races reserve trackers this day.</Text>
                    </div>
                ) : (
                    <div class='list-group'>
                        {races.map(race => (
                            <a
                                key={race.id}
                                href={`/race/${race.id}/admin/edit`}
                                class='list-group-item list-group-item-action d-flex justify-content-between align-items-center'
                            >
                                <span>
                                    <span class='badge me-2' style={raceBadgeStyle(race)}>
                                        {race.phase === 'race'
                                            ? <Text id='tracker-calendar.phase-race'>Race day</Text>
                                            : <Text id='tracker-calendar.phase-shipping'>Shipping</Text>}
                                    </span>
                                    {race.title}
                                    <small class='d-block text-body-secondary'>
                                        <Text id='tracker-calendar.signups-and-estimate' fields={{ signups: race.signups, estimate: race.estimatedTrackers }}>
                                            {race.signups} signed up · estimate {race.estimatedTrackers}
                                        </Text>
                                    </small>
                                </span>
                                <span class='fw-bold'>
                                    <i class='fa-duotone fa-user me-1' />
                                    {race.trackersNeeded}
                                </span>
                            </a>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default RaceTrackerDayDrawer;
